/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProductCategoryItem } from '../../models/product-category-item';

export interface ProductCategoryControllerGetOneWithChildren$Params {
  id: number;
  query?: string;
  limit?: number;
  skip?: number;
  cat_id?: number;
}

export function productCategoryControllerGetOneWithChildren(http: HttpClient, rootUrl: string, params: ProductCategoryControllerGetOneWithChildren$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>> {
  const rb = new RequestBuilder(rootUrl, productCategoryControllerGetOneWithChildren.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('cat_id', params.cat_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProductCategoryItem;
      }>;
    })
  );
}

productCategoryControllerGetOneWithChildren.PATH = '/product/product-category/{id}/detail';
